// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityUserMemberships = {
  drawers: {
    membership: "認可 · {name}",
    membershipShort: "認可",
  },
  alerts: {
    membershipEditMode:
      "このドロワーはプラットフォームロールの全量編集に対応します。選択済みロールは保持され、新規ロールは追加され、既存ロールは選択解除で削除されます。送信時に差分で追加・削除します。",
    membershipNoExistingRoles: "現在割り当て済みのプラットフォームロールはありません。",
  },
  confirms: {
    removeMembershipTitle: "プラットフォームロール割当を削除",
    removeMembershipDescription: "{value} を削除しますか？",
  },
  messages: {
    membershipRemoved: "プラットフォームロール割当を削除しました",
    membershipRemoveFailed: "プラットフォームロール割当の削除に失敗しました",
    membershipCreated:
      "プラットフォームロール割当が完了しました。{count} 件追加し、既存 {skippedCount} 件をスキップしました",
    membershipCreatedWithPartialFailures:
      "プラットフォームロール割当は一部完了しました。追加 {successCount} 件、既存スキップ {skippedCount} 件、失敗 {failedCount} 件：{details}",
    membershipCreateFailed: "プラットフォームロール割当に失敗しました",
    membershipCreateFailedForRole: "プラットフォームロール割当に失敗しました：{role}",
    membershipAllRolesAlreadyAssigned: "選択したプラットフォームロールはすべて既に割り当て済みです",
    membershipUpdated:
      "ユーザー認可を更新しました。プラットフォームロールを {createdRoleCount} 件追加し、{removedRoleCount} 件削除し、組織所属を {createdOrganizationMembershipCount} 件追加し、{removedOrganizationMembershipCount} 件削除しました",
    membershipUpdatedWithPartialFailures:
      "ユーザー認可は一部更新されました。プラットフォームロールを {createdRoleCount} 件追加し、{removedRoleCount} 件削除し、組織所属を {createdOrganizationMembershipCount} 件追加し、{removedOrganizationMembershipCount} 件削除し、失敗 {failedCount} 件：{details}",
    membershipUpdateFailed: "プラットフォームロール割当の更新に失敗しました",
    membershipRemoveFailedForRole: "プラットフォームロールの削除に失敗しました：{role}",
    membershipNoChanges: "プラットフォームロールと組織所属に変更はありません",
    organizationMembershipContextUnavailable:
      "組織主体を特定できません。先に組織ツリーを初期化してください",
    organizationMembershipCreateFailed: "組織所属の追加に失敗しました",
    organizationMembershipRemoveFailedForUnit: "組織所属の削除に失敗しました：{unit}",
  },
  forms: {
    organizationMembershipsHint:
      "ここではユーザーの実際の組織所属を管理します。複数の組織ノードに同時に所属させられます。",
    organizationMembershipsUnavailable:
      "まだ利用可能な組織ツリーがありません。先に組織ページで組織ツリーを初期化してください。",
  },
} as const;
